import Vue from 'vue';
import moment from 'moment';
import { join } from 'lodash-es';
moment.suppressDeprecationWarnings = true;

export default function init() {
    Vue.filter('date_MDY_Slash', (value: string) => {
        if (!value) return '';
        return moment(String(value)).format('MM/DD/YYYY');
    });

    Vue.filter('date_MDY_Hyphen', (value: string) => {
        if (!value) return '';
        return moment(String(value)).format('MM-DD-YYYY');
    });

    Vue.filter('date_MDYT_Slash', (value: string) => {
        if (!value) return '';
        return moment(String(value)).format('MM/DD/YYYY HH:MM:SS');
    });

    Vue.filter('capitalizeEach', (value: string) => {
        if (!value) return '';
        return value.replace(/\w\S*/g, function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    });

    Vue.filter('capitalizeFileName', (value: string) => {
        if (!value) return '';
        if (
            value.toLowerCase() == 'pod' ||
            value.toLowerCase() == 'bol' ||
            value.toLowerCase() == 'pbol' ||
            value.toLowerCase() == 'ppod'
        ) {
            return value.toUpperCase();
        }

        return value.replace(/\w\S*/g, function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    });

    Vue.filter('capitalize', (value: string) => {
        if (!value) return '';
        return value.charAt(0).toUpperCase() + value.slice(1).toLocaleLowerCase();
    });

    Vue.filter('lowercase', (value: string) => {
        if (!value) return '';
        return value.toLocaleLowerCase();
    });

    Vue.filter('uppercase', (value: string) => {
        if (!value) return '';
        return value.toUpperCase();
    });

    Vue.filter('dollar', (value: string | number) => {
        let num = 0;
        let type = typeof value;
        if (type != 'string' && type != 'number') {
            return '';
        }
        if (typeof value == 'string') {
            num = parseFloat(value);
            if (isNaN(num)) {
                return '';
            }
        } else if (typeof value == 'number') {
            num = value;
        }
        let money = num.toFixed(2);
        return `$${money}`;
    });

    Vue.filter('weight', (value: string | number) => {
        let num = 0;
        let type = typeof value;
        if (type != 'string' && type != 'number') {
            return '';
        }
        if (typeof value == 'string') {
            num = parseFloat(value);
            if (isNaN(num)) {
                return '';
            }
        } else if (typeof value == 'number') {
            num = value;
        }
        let weight = num.toFixed(2);
        return weight + ' lbs';
    });

    Vue.filter('timeFormat', (value: string | number, format: string) => {
        if (!value) return '';
        return moment(value).format(format);
    });

    Vue.filter('timeFormatSMD', (value: string | number, lenght: number) => {
        if (!value) return '';
        let time = moment(value).format('LLLL');
        return join(time.split(',').slice(0, lenght), ',');
    });

    Vue.filter('substr', (value: any, format: number) => {
        if (!value) return;
        if (typeof value == 'string') return value.substr(0, value.indexOf('.') + format);
        if (typeof value == 'number') return value.toFixed(format);
    });

    Vue.filter('negativeAmount', (value: any) => {
        if (!value) return;
        let amount = Number(value);
        if (amount < 0) return '-$' + Math.abs(amount).toFixed(2);
        else return '$' + amount.toFixed(2);
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/filters/index.ts